const bodyScrollManager = {
  counter: 0,

  add(): void {
    if (this.counter === 0) {
      document.body.classList.add('!overflow-hidden');
    }
    this.counter++;
  },

  remove(): void {
    this.counter = Math.max(0, this.counter - 1);

    if (this.counter === 0) {
      document.body.classList.remove('!overflow-hidden');
    }
  },
};

export default bodyScrollManager;
